export default function AuthLayout() {
	return (
		<div className="d-none d-md-flex w-50 bg-dark align-items-center justify-content-center">
			<div className="container no-boxShadow bg-dark d-flex justify-content-center">
				<h1 className="text-white">nextest.io</h1>
			</div>
		</div>
	);
}
